export const DataPoint = ({
  cx,
  cy,
  colors,
  index,
  isAnomaly,
  r = 2.5,
}: {
  cx: number;
  cy: number;
  colors: string[];
  index: number;
  isAnomaly: boolean;
  r?: number;
}) => {
  if (!cx || !cy) return <div></div>;

  if (isAnomaly) {
    return (
      <circle cx={cx} cy={cy} r={5} fill="url(#orangeYellowDotGradient)" />
    );
  }
  return (
    <circle
      cx={cx}
      cy={cy}
      r={r}
      fill="white"
      stroke={colors[index]}
      strokeWidth={1}
    />
  );
};
